import { ChatBlkTelemetryService } from '../services';
import { ChatBlkQuery, telemetryFunctionMap } from '../types';

const {
    CHATBLK_MFE_FUNCTION_INFO_POPOVER_OPENED,
    CHATBLK_MFE_FUNCTION_INFO_POPOVER_CLOSED,
} = telemetryFunctionMap;

/**
 * Custom hook that builds and manages the state of a popover for displaying information.
 *
 * @param data - The data that was target of popover.
 * @param query - Optional query object containing additional information for telemetry tracking.
 * @returns An object containing telemetry tracking functions.
 *
 * @property {Function} trackInfoPopoverOpenedTelemetry - Function to track telemetry when the popover is opened.
 * @property {Function} trackInfoPopoverClosedTelemetry - Function to track telemetry when the popover is closed.
 */
const useInfoPopoverBuilder = (data: string, query?: ChatBlkQuery) => {
    let isPopoverOpen = false;

    const trackInfoPopoverOpenedTelemetry = () => {
        ChatBlkTelemetryService.track(
            CHATBLK_MFE_FUNCTION_INFO_POPOVER_OPENED,
            { data },
            query?.id
        );
        isPopoverOpen = true;
    };

    const trackInfoPopoverClosedTelemetry = () => {
        /**
         * popoverClosed events are emitted when popovers are unmounted.
         * To avoid duplicate popover closed telemetry events, only track if the panel was
         * previously open and is now being closed
         */
        if (isPopoverOpen) {
            isPopoverOpen = false;
            ChatBlkTelemetryService.track(
                CHATBLK_MFE_FUNCTION_INFO_POPOVER_CLOSED,
                { data },
                query?.id
            );
        }
    };

    return {
        trackInfoPopoverOpenedTelemetry,
        trackInfoPopoverClosedTelemetry,
    };
};

export default useInfoPopoverBuilder;
